export var FileSizeUnitEnum;
(function (FileSizeUnitEnum) {
    FileSizeUnitEnum["BYTE"] = "byte";
    FileSizeUnitEnum["KILO_BYTE"] = "kiloByte";
    FileSizeUnitEnum["MEGA_BYTE"] = "megaByte";
    FileSizeUnitEnum["GIGA_BYTE"] = "gigaByte";
    FileSizeUnitEnum["TERA_BYTE"] = "teraByte";
    FileSizeUnitEnum["PETA_BYTE"] = "petaByte";
})(FileSizeUnitEnum || (FileSizeUnitEnum = {}));
//# sourceMappingURL=documents.js.map